// extracted by mini-css-extract-plugin
export var dropdownIcon = "_ol-6";
export var imgContainer = "_ol-3";
export var menuIcon = "_ol-5";
export var pillWrapper = "_ol-2";
export var pillsContainer = "_ol-1";
export var subscriptionCard = "_ol-0";
export var subscriptionLogo = "_ol-4";